import Layout from '@/layout'

const route = {
  path: '/dxj/list',
  component: Layout,
  redirect: '/dxj/list',
  alwaysShow: true, // will always show the root menu
  name: 'DXJList',
  meta: {
    title: '懂小剧',
    icon: 'DXJ',
    roles: [
      'dxj'
    ]
  },
  children: [
    {
      path: '/dxj/strategy/index',
      // component: () => import('@/views/dxj/strategy/index.vue'),
      component: () => import('@/views/dxj/Materials/index.vue'),
      name: 'dxjAccountList',
      meta: {
        title: '短剧',
        // icon: 'component',
        roles: [
          'adx.material'
        ]
      }
    },
    {
      path: '/dxj/MaterialsInfo/index',
      component: () => import('@/views/dxj/Materials/Info/index.vue'),
      name: 'dxjMaterialInfo',
      meta: {
        title: '短剧素材',
        // icon: 'component',
        roles: [
          'adx.strategy'
        ]
      }
    },
    {
      path: '/dxj/MaterialNovel/index',
      component: () => import('@/views/dxj/Materials/Info/novel.vue'),
      name: 'dxjMaterialNovel',
      meta: {
        title: '小说素材',
        // icon: 'component',
        roles: [
          'dxj.material.novel_list'
        ]
      }
    }
  ]
}

export default route
